import React from 'react';

interface IProps {
  light?: boolean;
  
}

const SelectUpIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0.2 22 22">
      <circle r="8" fill={props.light?"":"#122442"} transform="matrix(1 0 0 -1 11 11.7)"/>
      <path fill={props.light?"#ccc":"#fff"} d="M6.4 14.7l4.6-4.6 4.6 4.6 1.4-1.4-6-6-6 6 1.4 1.4z"/>
    </svg>
  )
}

export default SelectUpIcon;